export const tr = {
    today: 'Bugün',
    tomorrow: 'Yarın',
    yesterday: 'Dün'
};
